import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls window to top on every route change.
 * Mounted once inside <BrowserRouter>.
 * Skips scrolling when the URL has a #hash — the browser handles that natively.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // respect #anchor targets like /faq#legacy-book
    // 'auto' = instant (unlike the non-standard 'instant').
    // Also reset document.documentElement.scrollTop for Safari/Firefox quirks.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    } catch { /* ignore */ }
  }, [pathname, hash]);
  return null;
}
